// extracted by mini-css-extract-plugin
export default {"Header":"Header_Header__7dQ1d","logo":"Header_logo__63JCl"};